"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        return _this;
    }
    Checkbox.prototype.render = function () {
        var _a = this.props, label = _a.label, name = _a.name, id = _a.id, value = _a.value, disabled = _a.disabled;
        return ((0, jsx_runtime_1.jsx)("div", { className: "falcon-checkbox form-group ".concat(this.props.className || ""), children: (0, jsx_runtime_1.jsx)("div", { className: "d-flex", children: (0, jsx_runtime_1.jsxs)("div", { className: "form-check mr-3", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input true", onChange: this.handleOnChange, type: "checkbox", "aria-labelledby": "".concat(id, "-label"), name: name, id: id, checked: value, disabled: disabled || false }), (0, jsx_runtime_1.jsxs)("label", { id: "".concat(id, "-label"), className: "custom-control-label", htmlFor: id, children: [(0, jsx_runtime_1.jsx)("div", { className: "checkbox-big" }), (0, jsx_runtime_1.jsx)("div", { className: "checkbox-label", children: (0, jsx_runtime_1.jsx)("p", { children: label }) })] })] }) }) }));
    };
    Checkbox.prototype.handleOnChange = function (event) {
        var checked = event.target.checked;
        this.props.onChanged(checked);
    };
    return Checkbox;
}(React.Component));
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map